/* ============================================================
   THE STEEPED LETTER CO. — shared section behaviour
   Scroll reveals, the marquee gallery, and the membership block.
   Loaded once from layout/theme.liquid. Every piece no-ops if its
   markup isn't present, and it re-runs when the theme editor swaps
   a section in and out.
   ============================================================ */
(function () {
  "use strict";

  var reduce = window.matchMedia &&
               window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveals ---------- */
  function reveals(scope) {
    var els = (scope || document).querySelectorAll('.slc .rv:not(.in)');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('in');
        io.unobserve(en.target);
      });
    // threshold must stay 0. A percentage threshold can never be met by an
    // element taller than the viewport divided by that percentage, so a tall
    // section would sit at opacity 0 forever. rootMargin does the "wait until
    // it's a bit into view" job instead, and works at any element size.
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });

    Array.prototype.forEach.call(els, function (el, i) {
      el.style.transitionDelay = (Math.min(i % 3, 2) * 110) + 'ms';
      io.observe(el);
    });
  }

  /* ---------- reveal backstop ----------
     IntersectionObserver can miss an element during a fast flick-scroll:
     the entry gets coalesced away and that element sits at opacity 0 for
     the rest of the pageview, with its content invisible.

     Deliberately on a timer rather than requestAnimationFrame. rAF is
     suspended entirely in a background or hidden tab, which is exactly
     the case where the observer is least reliable — a backstop that only
     runs when the tab is in front is not a backstop. A timer still fires
     (throttled) when hidden, so content is never stranded invisible.     */
  var sweepQueued = false;
  function sweep() {
    if (sweepQueued) return;
    sweepQueued = true;
    setTimeout(function () {
      sweepQueued = false;
      var left = document.querySelectorAll('.slc .rv:not(.in)');
      if (!left.length) {
        window.removeEventListener('scroll', sweep);
        return;
      }
      Array.prototype.forEach.call(left, function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.88) {
          el.classList.add('in');
        }
      });
    }, 60);
  }

  /* ---------- marquee gallery ----------
     The track is duplicated so the -50% keyframe loops seamlessly.
     Duplicating in JS rather than Liquid keeps the markup half the
     size and stops screen readers reading every photo twice.       */
  function marquee(scope) {
    var tracks = (scope || document).querySelectorAll('.slc-gal-track:not([data-doubled])');
    Array.prototype.forEach.call(tracks, function (track) {
      track.setAttribute('data-doubled', 'true');
      track.innerHTML += track.innerHTML;
    });
  }

  /* ---------- membership block ---------- */
  function membership(scope) {
    var roots = (scope || document).querySelectorAll('[data-slc-membership]:not([data-ready])');

    Array.prototype.forEach.call(roots, function (root) {
      root.setAttribute('data-ready', 'true');

      var q = function (n) { return root.querySelector('[data-slc="' + n + '"]'); };
      var opts = Array.prototype.slice.call(root.querySelectorAll('.slc-opt'));
      var amt = q('amt'), per = q('per'), save = q('save'), note = q('note');
      var vid = q('vid'), plan = q('plan'), add = q('add');

      if (!opts.length || !vid || !add) return;

      function select(btn) {
        if (!btn || btn.hasAttribute('disabled')) return;

        opts.forEach(function (o) {
          o.classList.remove('on');
          o.setAttribute('aria-checked', 'false');
          o.tabIndex = -1;
        });
        btn.classList.add('on');
        btn.setAttribute('aria-checked', 'true');
        btn.tabIndex = 0;

        if (amt)  amt.innerHTML  = btn.getAttribute('data-amt') || '';
        if (per)  per.innerHTML  = btn.getAttribute('data-per') || '';
        if (save) save.innerHTML = btn.getAttribute('data-save') || '';
        if (note) note.textContent = btn.getAttribute('data-note') || '';

        vid.value = btn.getAttribute('data-vid');

        // The whole point of this section: attach the selling plan
        // when the variant has one, and post nothing at all when it
        // doesn't. An empty selling_plan is rejected by /cart/add,
        // so the input is disabled rather than blanked.
        var planId = btn.getAttribute('data-plan');
        if (plan) {
          if (planId) {
            plan.value = planId;
            plan.disabled = false;
          } else {
            plan.value = '';
            plan.disabled = true;
          }
        }
      }

      opts.forEach(function (o) {
        o.addEventListener('click', function () { select(o); });
        o.addEventListener('keydown', function (e) {
          var keys = ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'];
          if (keys.indexOf(e.key) === -1) return;
          e.preventDefault();
          var i = opts.indexOf(o);
          var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
          var next = opts[(i + step + opts.length) % opts.length];
          select(next);
          next.focus();
        });
      });

      var initial = root.querySelector('.slc-opt.on') || opts[0];
      if (initial) {
        select(initial);
      } else {
        add.disabled = true;
        add.textContent = 'Currently unavailable';
      }

      // gallery
      var thumbs = root.querySelector('[data-slc="thumbs"]');
      var main   = root.querySelector('[data-slc="main"]');
      if (thumbs && main) {
        Array.prototype.forEach.call(thumbs.children, function (b) {
          b.addEventListener('click', function () {
            Array.prototype.forEach.call(thumbs.children, function (x) {
              x.classList.remove('on');
            });
            b.classList.add('on');
            main.classList.add('slc-swap');
            setTimeout(function () {
              main.src = b.getAttribute('data-full');
              main.alt = b.getAttribute('data-alt') || '';
              main.classList.remove('slc-swap');
            }, reduce ? 0 : 200);
          });
        });
      }
    });
  }

  function boot(scope) {
    reveals(scope);
    marquee(scope);
    membership(scope);
    window.addEventListener('scroll', sweep, { passive: true });
    sweep();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  window.addEventListener('load', function () { sweep(); });

  // Theme editor: sections are injected after load.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
